module.exports = __webpack_public_path__ + "static/icd-coding-fbc5879eb665c8c925c289a37b14b44a.jpg";